var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { API_BASE_URL } from "../auth/routers/AuthRouter";
import CredentialRepository from "./CredentialRepository";
const CredentialListApiRepository = {
    fetchData: (skip, pageSize, params, sortName, sortDirection) => {
        let paramQuery = "";
        if (params != undefined) {
            params.forEach((value, key) => {
                paramQuery += `&${key}=${value}`;
            });
        }
        let url = `${API_BASE_URL}/api/v1/credentials?limit=${pageSize}&offset=${skip}${paramQuery}`;
        if (sortName != undefined && sortName != "") {
            url = `${url}&sortName=${sortName}`;
        }
        if (sortDirection != undefined && sortDirection != "") {
            url = `${url}&sortDirection=${sortDirection.toUpperCase()}`;
        }
        return new Promise((resolve) => __awaiter(void 0, void 0, void 0, function* () {
            const result = yield CredentialRepository.get(url);
            resolve(result.data);
        }));
    }
};
export default CredentialListApiRepository;
//# sourceMappingURL=CredentialListApiRepository.js.map